export default __webpack_public_path__ + "static/media/attach.1e2a56de.svg";